import React from 'react';
import { jobPhase } from '../constants/jobPhase';

// Szolgáltatói folyamat (case_jobs) jelvény kanban-kártyán / lista-soron.
// Csak staff kapja meg a szükséges mezőket a backendtől (lásd
// caseController.js listCases), ezért itt elég a mezők meglétét nézni.
const JobBadge = ({ count, leadStatus, t }) => {
  if (!count) return null;
  const phase = jobPhase(leadStatus);
  return (
    <span
      className={`job-badge job-badge--${phase}`}
      title={t('jobs.openJobsWarning').replace('{n}', count)}
    >
      🔧 {count}
    </span>
  );
};

export default JobBadge;
